/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Doc_Type_Chattels_ListInputs */

const en_doc_type_chattels_list = /** @type {(inputs: Doc_Type_Chattels_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chattels List`)
};

const id_doc_type_chattels_list = /** @type {(inputs: Doc_Type_Chattels_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daftar Barang Bergerak`)
};

/** @type {(inputs: Doc_Type_Chattels_ListInputs) => LocalizedString} */
const es_doc_type_chattels_list = en_doc_type_chattels_list;

/** @type {(inputs: Doc_Type_Chattels_ListInputs) => LocalizedString} */
const fr_doc_type_chattels_list = en_doc_type_chattels_list;

/** @type {(inputs: Doc_Type_Chattels_ListInputs) => LocalizedString} */
const de_doc_type_chattels_list = en_doc_type_chattels_list;

/** @type {(inputs: Doc_Type_Chattels_ListInputs) => LocalizedString} */
const ja_doc_type_chattels_list = en_doc_type_chattels_list;

/** @type {(inputs: Doc_Type_Chattels_ListInputs) => LocalizedString} */
const zh_doc_type_chattels_list = en_doc_type_chattels_list;

/** @type {(inputs: Doc_Type_Chattels_ListInputs) => LocalizedString} */
const ar_doc_type_chattels_list = en_doc_type_chattels_list;

/** @type {(inputs: Doc_Type_Chattels_ListInputs) => LocalizedString} */
const it_doc_type_chattels_list = en_doc_type_chattels_list;

/** @type {(inputs: Doc_Type_Chattels_ListInputs) => LocalizedString} */
const ru_doc_type_chattels_list = en_doc_type_chattels_list;

/** @type {(inputs: Doc_Type_Chattels_ListInputs) => LocalizedString} */
const pt_doc_type_chattels_list = en_doc_type_chattels_list;

/** @type {(inputs: Doc_Type_Chattels_ListInputs) => LocalizedString} */
const ko_doc_type_chattels_list = en_doc_type_chattels_list;

/**
* | output |
* | --- |
* | "Chattels List" |
*
* @param {Doc_Type_Chattels_ListInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const doc_type_chattels_list = /** @type {((inputs?: Doc_Type_Chattels_ListInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Doc_Type_Chattels_ListInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_doc_type_chattels_list(inputs)
	if (locale === "es") return es_doc_type_chattels_list(inputs)
	if (locale === "fr") return fr_doc_type_chattels_list(inputs)
	if (locale === "de") return de_doc_type_chattels_list(inputs)
	if (locale === "ja") return ja_doc_type_chattels_list(inputs)
	if (locale === "zh") return zh_doc_type_chattels_list(inputs)
	if (locale === "ar") return ar_doc_type_chattels_list(inputs)
	if (locale === "id") return id_doc_type_chattels_list(inputs)
	if (locale === "it") return it_doc_type_chattels_list(inputs)
	if (locale === "ru") return ru_doc_type_chattels_list(inputs)
	if (locale === "pt") return pt_doc_type_chattels_list(inputs)
	return ko_doc_type_chattels_list(inputs)
});